import { Component } from '@opten/compiler/metadata/component';
import Slider, { ISliderOptions } from '@opten/slider';

@Component({ className: 'js-slider', observe: true })
export class SliderComponent {
	constructor(private element: HTMLElement) {
		const behaviors = [];

		const options: ISliderOptions = {
			infinite: 1,
			rewind: false
		};

		const instance = new Swiper(this.element, {
			loop: false,
			autoplay: {
				delay: 5000
			},
			navigation: {
				nextEl: '.js-next',
				prevEl: '.js-prev'
			}
		});
	}
}
